import axios from "axios";

// Wajib di-set di .env / .env.production (mis. https://api.arunikamedina.company).
// Kosong hanya masuk akal saat dev lokal dengan "proxy" di package.json.
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "",
  timeout: 10000,
});



export default axiosInstance;